<template>
    <div class="container">
        <!-- <h1>Nhập liệu</h1>

        <hr/> -->

        <div class="row mt-2">
            <template v-for="input in forms">

            <div :class="'col-md-'+(input.colspan?input.colspan:6)" v-if="input.type=='line'" v-bind:key="input.col">
                <hr/>
            </div>

            <div :class="'col-md-'+(input.colspan?input.colspan:6)" v-if="input.type=='label'" v-bind:key="input.col">
                <h2>{{input.defaultValue}}</h2>
            </div>

            <b-form-group :class="'col-md-'+(input.colspan?input.colspan:6)" v-bind:key="'f'+input.col" v-if="input.visible && isFormControl(input)" :set="field = columns[input.col]">
                    <label class="input-header" >{{field.alias}} <span v-if="input.required" class="text-red">*</span> </label>
                    <b-button class="ml-1" variant="warning" size="sm" v-if="input.hint" v-b-popover.hover.top="input.hint">?</b-button>

                    <p variant="danger" class="text-red" show v-if="input.error">{{input.error}}</p>

                    <br/>
                    <p class="badge" v-if="debugMode">({{input.value}})</p>

                    <div v-if="input.type=='image'">
                        <img-form-field :image_url="input.value" @image_changed="input.value=$event"></img-form-field>
                    </div>

                    <div v-if="input.type=='date'">
                        <b-form-input 
                            type="date" 
                            v-model="input.value" 
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            />
                    </div>

                    <div v-if="input.type=='checkbox'">
                        <b-form-checkbox
                            v-model="input.value"
                            value="true"
                            unchecked-value="false"
                            :disabled="input.disabled"
                            >
                            {{field.alias}}
                            </b-form-checkbox>
                    </div>

                    <div v-if="input.type=='text'">
                        <b-form-input type="text" 
                            v-model="input.value" 
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            />
                    </div>

                    <div v-if="input.type=='link'">
                        <b-form-input type="text" 
                            v-model="input.value" 
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            />
                    </div>

                    <div v-if="input.type=='textarea'">
                        <b-form-textarea
                            :id="input.col"
                            v-model="input.value"
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            rows="3"
                            ></b-form-textarea>
                    </div>

                    <div v-if="input.type=='select'">
                        <b-form-select 
                            v-model="input.value" 
                            :options="field.options"  
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            @change="input.change?input.change($event,forms):function(){}"
                            ></b-form-select>
                    </div>

                    <div v-if="input.type=='multi-select'">
                        <multiselect 
                            v-model="input.value" 

                            :searchable="false"
                            :close-on-select="false"
                            :multiple="true"
                            :options="field.options"
                            :placeholder="field.alias"
                            :disabled="input.disabled">
                            </multiselect>
                    </div>

                    <div v-if="input.type=='typeahead'">

                        <vue-bootstrap-typeahead 
                            v-model="input.value"
                            :minMatchingChars="1"
                            :data="input.options"
                            :serializer="input.optionLabel"
                            @hit="typeaheadHitEvent($event,input)"
                            :placeholder="field.alias"
                            :disabled="input.disabled"
                            ref="typeahead"
                            /> 
                    </div>

                    <div v-if="input.type=='number'">
                        <b-form-input 
                            type="number" 
                            v-model="input.value"  
                            step="0.001" 
                            min="0.000" 
                            max="1000000.000"
                            :placeholder="field.alias"
                            :disabled="input.disabled"/>
                    </div>

                    <div v-if="input.type=='image_list'">
                        <img-list-form-field 
                            :list_urls="input.value"
                            :images_folder="images_table"
                            @list_changed="input.value=$event"></img-list-form-field>
                    </div>
                
            </b-form-group>
            </template>
        </div>

        <div class="row" v-if="isLoading">
            Loading...
        </div>

        <div class="row" v-if="!isLoading">
            <div class="col-md-3 offset-md-9">
                <b-button variant="primary" size="large" @click="submit()">Lưu lại</b-button>
            </div>
        </div>
    </div>

</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import Multiselect from 'vue-multiselect'

import Constants from '@/constants'
import TableMeta from '@/models/OnlineScanTableMeta'
import StreetData from '@/models/StreetData'
import moment from 'moment'
import axios from 'axios'
import Firebase from "../../services/firebase.js"
import ImageFormField from '@/views/base/ImageFormField'
import ImagesFormField from '@/views/base/ImagesFormField'

export default {
  name: 'GenericGroupFormView',
  components: {
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
    Multiselect,
    'img-form-field': ImageFormField,
    'img-list-form-field': ImagesFormField
    },
  props: ['rootPath', 'forms', 'columns', 'table_name', 'ids'],
  data () {
    return {
        debugMode: false,
        fields_map: {},
        id: null,
        isLoading: false,
    }
  },
  computed: {
    entity() {
        return this.table_name.split('.')[1].slice(0, -1);
    },
    role() {
      console.log('trying to get user role: ', this.$store.state.userRole)
      if (this.$store.state.userRole) {
        return this.$store.state.userRole;
      }

      return 'ctv'; // default role
    },

    email() {
      console.log('trying to get user email: ', this.$store.state.userEmail)
      if (this.$store.state.userEmail) {
        return this.$store.state.userEmail;
      }

      return ''; // empty
    }
  },
  watch: {

  },
  methods: {
    isFormControl(input) {
        return input.type!='line' && input.type != 'label'
    },
    getValueFromField (field) {
        if(field.value) {
            if(field.value instanceof Array && field.type === 'image_list') {
                var s = JSON.stringify(field.value);
                return "'" + s + "'";
            }
            else if(field.value instanceof Array) {
                return "'" + field.value.join(',') + "'";
            } else if(field.value instanceof String) {
                return "'" + field.value + "'";
            } else {
              if(field.type === 'text' 
                || field.type === 'select' 
                || field.type === 'multi-select'
                || field.type === 'textarea' 
                || field.type === 'typeahead' 
                || field.type === 'image'
                ) {
                  return "'" + field.value + "'";
              }
              else if(field.type === 'date') {
                  return "'" + moment(field.value).format("yyyy-MM-DD") + "'";
              }
              else {
                  return field.value;
              }
            }
        }

        return null;
    },

    typeaheadHitEvent (event, input) {
        if(input.hitFunction) {
            input.hitFunction(event, this.forms, input);
        }
        input.value = event.ward + ' > ' + event.street + ' > ' + event.street_2
    },

    generateUpdateQuery() {
        var columns = [];
        for(var i in this.forms) {
            var f = this.forms[i];
            if(f.value && (f.type != 'label') && (f.type != 'label') && (f.type != 'line') || (f.col == 'image_list')) {
                columns.push(f.col + '=' + this.getValueFromField(f));
            }
        }

        console.log("columns to update: ", columns);

        if (columns.length == 0) {
            return null;
        }

        var query = 'UPDATE ' + this.table_name + ' SET ';
        query += columns.join(',');
        query += ` WHERE id IN (${this.ids});`;

        return query;
    },

    resetValidationState() {
        for(var i =0; i<this.forms.length; i++) {
            this.forms[i].error = null;
        }
    },

    validateInput() {
        var hasError = false;

        // Field need to comply to the validation rules
        for(var i =0; i<this.forms.length; i++) {
            var f = this.forms[i];
            if(f.value && f.validationFunc) {
                var result = f.validationFunc(f);
                
                if(!result) {
                    hasError = true;
                }
            }
        }

        if(hasError) {
            return false;
        }

        return true;
    },

    async updateExistingRecords() {
        this.isLoading = true;
        var query = this.generateUpdateQuery();
        console.log(query);

        if (query) {
            var url = Constants.HOST_URL + 'runQuery/insert';

            try {
                var response = await axios.post(url,{
                    query: query
                });
                console.log(response.data);
            }
            catch (e) {
                alert(e);
            }
        }

        this.isLoading = false;
    },

    async submit() {
        this.isLoading = true;

        this.resetValidationState();

        var ret = this.validateInput();
        if(!ret) {
            console.log('validation falied');
            alert('Có lỗi trong quá trình nhập liệu, vui lòng kiểm tra lại.');
            this.isLoading = false;
            return;
        }

        await this.updateExistingRecords();
 
        this.$emit("on-update-form-submitted")
    },

    resetFormValue () { 
        for(var i=0; i<this.forms.length;i++) {
            this.forms[i].value = this.forms[i].defaultValue;
        }
    },

  },
  mounted () {
    this.resetFormValue();
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped> 

.text-red {
    color: red;
}

.input-header {
    font-weight: bold;
}

.image {
    display: inline-block;
    margin: 5px;
    cursor: pointer;
}

.center-cropped {
  object-position: center; /* Center the image within the element */
  height: 150px;
  width: 150px;
}

.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
  transition: transform .2s;
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}

.selecting {
  border: 2px solid gray;
  padding: 10px;
}

.active {
  border: 3px solid blue;
}
</style>

<style>
.vbst-item {
    background: white;
}
</style>
